import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { timer } from 'rxjs';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BlockEndComponent, timer1 } from '../block-end/block-end.component';
import { BlocktimerComponent } from '../blocktimer/blocktimer.component';
import { HandlerService } from '../handler.service';
let i=0;
let j=0;


@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent {

  
 
  date = new Date();
  blockCheck: boolean = false; 
  blockShow: boolean = false; 
  unBlock: boolean = false;
  comments: any = ''; 
  labels: any = []; 
  blockData: any = []; 
  unBlockData: any = [];
  font; 
  blockStartTime; 
  blockEndTime;
  blockSlots:any=[];
  loader: boolean = false;
  msg;
  dateFormat;
  trainerFetch: boolean = true;

  constructor(public service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public dialog: MatDialog,
    public auth: AuthService) { }

  ionViewWillEnter() {
    this.loader = true;
    this.font = "normal";
    this.dateFormat = this.auth.getDateformat();
    let a = localStorage.getItem('fontSizeId');
    if (a == '1') {
      this.font = 'normal'
    }
    if (a == '2') {
      this.font = 'medium'
    }
    if (a == '3') {
      this.font = 'large'
    }
    this.search()
  }

  search() {
    this.loader = true;
    this.labels = [];
    this.blockData = [];
    this.blockSlots=[];
    this.unBlockData = [];
    let month = this.date.getMonth() + 1;
    var fmon;
    month < 10 ? fmon = '0' + month : fmon = month;
    let day = this.date.getDate();
    var fday;
    day < 10 ? fday = '0' + day : fday = day;
    let date = fday + '-' + fmon + '-' + this.date.getFullYear();
    let post = {
      "targetCenterId": localStorage.getItem('currentUserId'),
      "targetSource": localStorage.getItem('currentUserId'),
      "schElements": [1],
      "requestDate": date,
      "status": ["SlotsAvailable"],
      trainerFetch: this.trainerFetch
    }
    this.service.getCalendar(date, post).subscribe((res: any) => {
      if (res != null && res != "NO_CONTENT") {
        this.labels = res;
        this.labels.map((data: any) => {
          Object.assign(data, { color: "", data: [], remove: false });
        })
        this.getAppoints()
      }
      else {
        this.loader = false;
        this.handler.res('No data for you')
      }
    }, err => {
      this.loader = false;
      this.handler.err(err)
    })
  }

  getAppoints() {
    let month = this.date.getMonth() + 1;
    var fmon;
    month < 10 ? fmon = '0' + month : fmon = month;
    let day = this.date.getDate();
    var fday;
    day < 10 ? fday = '0' + day : fday = day;
    let date = this.date.getFullYear() + '-' + fmon + '-' + fday;
    let post = {
      statuses: [2, 3, 6],
      fromDate: date,
      toDate: date,
      serviceContractorId: localStorage.getItem('currentUserId'),
      trainerFetch: this.trainerFetch
    }
    this.service.getAppointReq2(post).subscribe((res: any) => {
      if (res != null && res != "NO_CONTENT" && res.length > 0) {
        let x: any = null;
        this.labels.map((data, i) => {
          res.map(val => {
            if (data.startTime == val.apptTime) {
              data.data.push(val);
              data.endTime = val.apptEndTime;
              x = val.apptEndTime;
              data.color = "highlight";
            }
            else if (x != null && data.color != "highlight") {
              data.remove = true;
              if (data.endTime == val.apptEndTime) {
                x = null;
              }
            }

          })
        })
        this.labels = this.labels.filter(res => res.remove != true)
      }
      else
        this.handler.res('No appointments for you')
    }, err => {
      this.handler.err(err);
      this.loader = false;
    })
    this.getBlocks();

  }

  getBlocks() {
    let month = this.date.getMonth() + 1;
    var fmon;
    month < 10 ? fmon = '0' + month : fmon = month;
    let day = this.date.getDate();
    var fday;
    day < 10 ? fday = '0' + day : fday = day;
    let date = this.date.getFullYear() + '-' + fmon + '-' + fday;
    this.service.getBlocks(date).subscribe((res: any) => {
      if (res != null) {
        this.labels.map((data: any) => {
          res.map((val: any) => {
            if (data.startTime == val.apptStartTime) {
              data.data.push(val);
              data.color = "block";
            }
          })
        })
      }
      this.loader = false;
    }, err => {
      this.loader = false;
      this.handler.err(err);
    })
  }

  next() {
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let dummy = new Date(x.setDate(x.getDate() + 1));
    this.date = dummy;
    this.search()
  }

  prev() {
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let dummy = new Date(x.setDate(x.getDate() - 1));
    this.date = dummy
    this.search()
  }

  open(id, item) {
    j=id;
    this.blockStartTime = item.startTime
    let x = this.labels.find(res => res.color == 'newblock');

    this.labels.map((res, i) => {
      if (i == id) {
        if (res.show || res.color == "block" || res.color == "unblock")
          res.show = false;
        else
          res.show = true;
      }
      else
        res.show = false;
    })
    let len = item.data.length;
    if (len == 0) {
      if (!this.unBlock) {
        if (item.color == 'newblock') {
          item.color = '';
          this.blockData = this.blockData.filter(res => res != item);
        }
        else {
          if(!x){
            this.blockShow = true;
            item.color = 'newblock';
            this.blockData.push(item);
          }
          else{
            this.labels.map(res=>{
              if(res.color == 'newblock')
              res.color = '';
              this.blockData=[];
              this.blockData.push(item);
            });
            item.color = 'newblock';
          }
          this.blockShow=false;
        }
        if (this.blockData.length > 0) {
          this.blockShow = true;
        }
        else {
          this.blockShow = false;
        }
      }
    }
    if (len == 1 && item.color != 'highlight') {
      if (!this.blockShow) {
        if (item.color == 'block') {
          item.color = 'unblock';
          this.unBlockData.push(item);
          this.unBlock = true;
        }
        else {
          item.color = 'block';
          let blen = this.unBlockData.length;
          if (blen > 0)
            this.unBlockData = this.unBlockData.filter(res => res != item);
        }
        if (this.unBlockData.length > 0) {
          this.unBlock = true;
        }
        else {
          this.unBlock = false;
        }
      }
    }
  }

  blockCall() {
    if(this.blockStartTime != this.blockEndTime){
      this.loader = true;
    this.blockCheck = false;
    this.blockShow = true;
    this.labels.map(res=>{
      if(res.startTime>=this.blockStartTime && res.endTime<=this.blockEndTime)
      this.blockSlots.push(res)
    })
    let blen = this.blockSlots.length - 1;
    let month = this.date.getMonth() + 1;
    var fmon;
    month < 10 ? fmon = '0' + month : fmon = month;
    let day = this.date.getDate();
    var fday;
    day < 10 ? fday = '0' + day : fday = day;
    let date = this.date.getFullYear() + '-' + fmon + '-' + fday;
    this.blockSlots.map((res, i) => {
      let post = {
        "targetCenterId": localStorage.getItem('organizationId'),
        "targetSource": localStorage.getItem('currentUserId'),
        "apptDate": date,
        "apptStartTime": res.startTime,
        "apptEndTime": res.endTime,
        "capacityDefId": res.capDefId,
        "centerId": localStorage.getItem('organizationId'),
        "apptStatusId": 1,
        "comments": this.comments,
        "type": 2,
        trainerFetch: this.trainerFetch
      }
      this.service.postAppointments(post).subscribe(res => {
        if (i == blen) {
          this.comments = '';
          this.handler.res('Blocked Successfully');
          this.blockSlots=[];
          this.blockStartTime=undefined;
          this.blockEndTime=undefined;
          this.handler.i=0;
          this.handler.j=0;
          this.loader = false;
          this.blockCheck = false;
          this.handler.check=false;
          this.blockShow = false;
          this.search();
        }
      }, err => {
        this.comments = '';
        this.blockCheck = false;
        this.blockShow = false;
        this.blockStartTime=undefined;
        this.blockEndTime=undefined;
        this.handler.i=0;
        this.handler.j=0;
        this.handler.check=false;
        this.handler.err(err);
        this.loader = false;
      })
    })
    }
    else{
      this.handler.error('Please Select Appropriate Start Time and End Time For Blocking Time Slots')
    }
  }

  unBlockCall() {
    let len = this.unBlockData.length - 1;
    this.loader = true;
    this.service.unBlockSlot(this.unBlockData[i].data[0].appointmentNbr).subscribe(res => {
      if (i < len) {
        i++;
        this.unBlockCall()
      }
      else {
        i = 0;
        this.handler.res("Slot Unblocked Successfully");
        this.loader = false;
        this.unBlock = false;
        this.ionViewWillEnter()
      }
      },
      err => {
        this.handler.err(err);
        this.loader = false;
      })
  }
  openModel(id): void {
    let data = [];
    for (let i = j; i < this.labels.length; i++) {
      if (this.labels[i].color != 'highlight' && this.labels[i].color != 'block') {
        data.push(this.labels[i]);
      }
      else {
        break;
      }
    }
    const dialogRef = this.dialog.open(BlocktimerComponent, {
      width: '100%',
      data: data
    });

    dialogRef.afterClosed().subscribe((res) => {
     if(res==2){
       this.blockStartTime=timer;
    }
    });
  }
  openModel1(): void {
    let data = [];
    for (let i = j; i < this.labels.length; i++) {
      if (this.labels[i].color != 'highlight'&& this.labels[i].color != 'block') {
        data.push(this.labels[i]);
      }
      else {
        break;
      }
    }
    const dialogRef = this.dialog.open(BlockEndComponent, {
      width: '100%',
      data: data
    });

    dialogRef.afterClosed().subscribe((res) => {
      if(res==2){
       this.blockEndTime=timer1;
      }
    });
  }
  cancel(){
    this.blockCheck=false;
    this.blockEndTime=undefined;
    this.blockStartTime=undefined;
    this.handler.i=0;
    this.handler.j=0;
    this.handler.check=false;
  }
}
